(function($) {
  var pageId = 'page-users-identity-verifiers-new',
      page = '#' + pageId;

  $(function() {
      $('body')
          .on('tr-identity-verifier:success', page, function(e) {
            let gotoUrl = this.dataset.returnUrl;
            let canLoad = $(".workspace").length;
            if (tower.stack && canLoad) {
              tower.stack.load(gotoUrl, {
                replace: true
              });
            } else if (tower.mobile) {
              tower.visit(gotoUrl);
            } else {
              location.href = gotoUrl;
            }
          });
  });
})(jQuery);
